<template>
  <OwnInput v-model="selectedDate" type="date" :min="min" :max="max" />
</template>

<script lang="ts" setup>
import { formatISO } from 'date-fns'
import { computed } from 'vue'

import { OwnInput } from '@/ui/OwnInput'

const props = withDefaults(
  defineProps<{
    /**
     * Disable past dates in the calendar picker. Does not prevent past dates from being entered manually.
     * @default false
     */
    future?: boolean
    /**
     * Disable future dates in the calendar picker. Does not prevent future dates from being entered manually.
     * @default false
     */
    disableFuture?: boolean
  }>(),
  { disableFuture: false, future: false }
)

const selectedDate = defineModel<string>()

const min = computed<string | undefined>(() => {
  if (props.future) {
    return formatISO(new Date(), { representation: 'date' })
  }

  return undefined
})

const max = computed<string | undefined>(() => {
  if (props.disableFuture) {
    return formatISO(new Date(), { representation: 'date' })
  }

  return undefined
})
</script>
